function asyncDelay(timerMs: number): Promise<number> {
  return new Promise(resolve => {
    setTimeout(resolve, timerMs, timerMs);
  });
}

export default asyncDelay;
